import { render, staticRenderFns } from "./Alisure.vue?vue&type=template&id=ae4a153c&scoped=true"
import script from "./Alisure.vue?vue&type=script&lang=js"
export * from "./Alisure.vue?vue&type=script&lang=js"
import style0 from "./Alisure.vue?vue&type=style&index=0&id=ae4a153c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4a153c",
  null
  
)

export default component.exports